const stadiums = [
    {
        slug: 'go-media-stadium',
        name: 'Go Media Stadium',
        names: ['go media stadium', 'mt smart stadium', 'mt smart'],
        streetAddress: '2 Beasley Ave',
        addressLocality: 'Auckland',
        postalCode: '1061',
        telephone: '+6493662048',
        latitude: -36.9182878,
        longitude: 174.81018
    },
    {
        '@type': 'StadiumOrArena',
        '@id': 'https://www.aucklandstadiums.co.nz/our-venues/western-springs-bowl',
        name: 'Western Springs Bowl',
        names: ['western springs bowl', 'western springs stadium', 'western springs'],
        streetAddress: 'Great North Rd',
        addressLocality: 'Auckland',
        postalCode: '1022',
        telephone: '+6493662048',
        url: 'https://www.aucklandstadiums.co.nz/our-venues/western-springs-bowl',
        openingHoursSpecification: [
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: [
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday'
                ],
                opens: '8:30',
                closes: '17:00'
            },
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: [
                    'Saturday',
                    'Sunday'
                ],
                opens: '00:00',
                closes: '00:00'
            }
        ]
    },
    {
        slug: 'north-harbour-stadium',
        name: 'North Harbour Stadium',
        names: ['north harbour stadium', 'north harbour'],
        streetAddress: 'Stadium Dr',
        addressLocality: 'Auckland',
        postalCode: '0632',
        telephone: '+6493747525',
        latitude: -36.7268156,
        longitude: 174.6993844
    }
];

function normalizedName(value) {
    return typeof value === 'string' ? value.toLowerCase().replace(/[-_]/g, ' ').trim() : '';
}

export function getStadiumBySlug(slug) {
    return stadiums.find((stadium) => stadium.slug === slug);
}

export function getStadiumByName(value) {
    const haystack = normalizedName(value);
    if (!haystack) return undefined;

    return stadiums.find((stadium) =>
        stadium.names.some((name) => haystack === name || haystack.includes(name))
    );
}
